import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import store from '../../../store';
import LocalStorage from '../../../components/DeviceStorage/LocalStorage';
import Utils from '../../../utils/Utils';

class MultiPurchaseButtonInfo extends AbstractRequestTask {
    constructor(groupIds = '') {
        super();
        this.group_ids = groupIds;
        const user = store.getState().user;
        this.user_token = user && user.user_token ? user.user_token : false;
    }

    getEncType() {
        return 'application/x-www-form-urlencoded';
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        let _url = `${http}${url}/services/payway/paymentservice/multipurchasebuttoninfo?`;
        _url += Utils.buildQueryParams(this.getGETParams());
        return _url;
    }

    getMethod() {
        return 'POST';
    }

    getParams() {
        const params = {};
        if(this.group_ids && Array.isArray(this.group_ids)){
            for(const x in this.group_ids){
                params[`group_ids[${x}]`] = this.group_ids[x];
            }
        }
        if (this.user_token) {
            params.token = this.user_token;
        } else {
            params.token = null;
        }

        return params;
    }

    getShowErrorModal() {
        return false;
    }

    getGETParams() {
        return super.getParams();
    }

    parseErrors(err) {
        console.log('[MultiplePBI] - api errors' + err);
    }

    getRetriesNumber() {
        return 0;
    }

    success(data, b) {
        this.resolve(data);
    }

    isValid(data) {
        return true;
    }

    getHeaders() {
        return {
            'Content-Type': 'application/x-www-form-urlencoded',
            // 'Accept': 'application/json',
        }
    }
}

export default MultiPurchaseButtonInfo;



// WEBPACK FOOTER //
// ./src/requests/tasks/search/MultiPurchaseButtonInfo.jsx